var _rect, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 187,
    height: 187,
    rx: 1.5,
    stroke: "#E0E0E0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 156,
    height: 156
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 156,
    height: 156,
    rx: 2,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.6287,
    cy: 47.6288,
    r: 21.9531,
    stroke: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8206 160.956L66.3137 104.929L87.7605 118.002L111.1 76.916L162.824 162.823",
    stroke: "#BDBDBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTemplate);
export default __webpack_public_path__ + "static/media/DefaultTemplate.297a08d56bcc626c048bb18e05f2a56a.svg";
export { ForwardRef as ReactComponent };